import styled from '@emotion/styled';

export const StyledTwoColumnsRow = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  & > div {
    width: calc(50% - 10px);
  }
`;

export const StyledWebhookLabel = styled.span`
  display: flex;
  gap: 5px;
  font-size: inherit;
`;

export const StyledClipBoardButton = styled.div`
  height: 14px;
  & button {
    height: 14px;
  }
`;
